export default function(r){for(var n in r)if(r.hasOwnProperty(n))return!1;return!0}
